import React, { useState } from 'react';
import { MenuIcon, XIcon, BookOpenIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Qué Incluye',
  href: '#que-incluye'
}, {
  label: 'Beneficios',
  href: '#beneficios'
}, {
  label: 'Precios',
  href: '#precios'
}, {
  label: 'Testimonios',
  href: '#testimonios'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };
  return <header className="fixed top-0 left-0 right-0 z-50 bg-navy-900/95 backdrop-blur-sm border-b border-navy-700/50" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-51">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 text-white" data-id="element-52">
            <BookOpenIcon className="h-6 w-6 md:h-8 md:w-8 text-gold-500" data-id="element-53" />
            <span className="font-bold text-sm md:text-lg" data-id="element-54">
              <span className="text-gold-500" data-id="element-55">Megapack</span> Lengua y
              Literatura
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" aria-label="Navegación principal" data-id="element-56">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-gray-300 hover:text-gold-400 transition-colors font-medium text-sm" data-id="element-57">
                {link.label}
              </a>)}
          </nav>

          {/* Mobile Menu Button */}
          <button type="button" className="md:hidden p-2 text-gray-300 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-expanded={mobileMenuOpen} aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-58">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-59" /> : <MenuIcon className="h-6 w-6" data-id="element-60" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-61">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-800 border-t border-navy-700" data-id="element-62">
            <nav className="px-4 py-4 space-y-2" aria-label="Navegación móvil" data-id="element-63">
              {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="block py-3 px-4 text-gray-300 hover:text-white hover:bg-navy-700 rounded-lg transition-colors font-medium" data-id="element-64">
                  {link.label}
                </a>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}